<template>
  <div class="h-dialogContainer h100">
    <div>
      <span>{{$t('SubscriberIms.dialogListSpan')}}{{sCount}}/{{tCount}}</span>
    </div>
    <div class="h-scroll">
    <ejs-grid ref='grid' :dataSource="data" >
      <e-columns>
        <e-column field='operObj' :headerText="$t('SubscriberIms.operObj')" width='150' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
        <e-column field='operResult' :headerText="$t('SubscriberIms.operResult')" width='150' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
      </e-columns>
    </ejs-grid>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogList',
  data() {
    return {
      sCount: 0,
      tCount: 1,
      data: [],
    };
  },
  methods: {
    addOperetionResult(infoData) {
      const $this = this;
      $this.data.splice(0, 0, infoData[0]);
    },
    addOperetionResultList(infoData) {
      console.log(infoData);
      const $this = this;
      this.tCount = infoData.length;
      infoData.forEach((item) => {
        if (item.operCode === '0' || item.operCode.split('.')[2] === '0') {
          this.sCount++;
        }
      });
      $this.data = infoData;
    },
    addUDMOperetionResultList(infoData) {
      console.log("77=====",infoData);
      const $this = this;
      this.tCount = infoData.length;
      infoData.forEach((item) => {
        if (item.operCode === 0 ) {
          this.sCount++;
        }
      });
      $this.data = infoData;
    },
    setTotalCount(tCount) {
      this.tCount = tCount;
    },
    setSuccessCount(sCount) {
      this.sCount = sCount;
    },
  }
};
</script>

<style scoped>

</style>
